module.exports = function requirePermission(permission) {
    return (req, res, next) => {
        const perms = req.user && req.user.permissions ? req.user.permissions : [];
        if (!perms.includes(permission)) {
            if (res.json) return res.json({ error: `Forbidden: Missing required permission '${permission}'` }, 403);
            res.writeHead(403, { 'Content-Type': 'application/json' });
            return res.end(JSON.stringify({ error: `Forbidden: Missing required permission '${permission}'` }));
        }
        next();
    };
};
